import { uniqBy } from 'lodash'

export default class {
	constructor(obj, stations, filters, themes, picture, favoriteFunction = '', executionFunction = '', deleteFunction = '', informationFunction = '', exportFunction = '', isUpdateData = false, exportHistory = [], selectionWatershed = [], keyFigures = []) {
		this.id = obj.id
		this.title = obj.title
		this.creationDate = obj.creationDate
		this.updateDate = obj.updateDate
		this.lastExecutionDate = obj.lastExecution
		this.state = obj.state
		this.stations = stations
		this.filters = filters
		this.themes = themes
		this.nbStation = stations ? uniqBy(stations, 'id').length : 0
		this.nbFilter = filters ? filters.length : 0
		this.nbTheme = themes ? themes.length : 0
		this.favoriteFunction = favoriteFunction
		this.executionFunction = executionFunction
		this.deleteFunction = deleteFunction
		this.informationFunction = informationFunction
		this.exportFunction = exportFunction
		this.picture = picture
		this.isUpdateData = isUpdateData
		this.exportHistory = exportHistory
		this.nbExport = exportHistory.length
		this.selectionWatershed = selectionWatershed
		this.nbWatershed = selectionWatershed.length
		this.keyFigures = keyFigures
		this.favorite = obj.favorite
		this.headers = ['isUpdateData', 'title', 'nbTheme', 'nbWatershed', 'nbStation', 'creationDate', 'updateDate', 'lastExecutionDate', 'favoriteFunction', 'informationFunction', 'executionFunction', 'exportFunction', 'deleteFunction']
	}
}




// WEBPACK FOOTER //
// ./src/dashboard/dto/DtoSelectionRow.js